<template>
  <span class="inline-coworkers-list">
    <DropdownTarget v-slot="{ show, visible }">
      <button @click="show" class="inline-coworkers-list__preview">
        <span class="inline-coworkers-list__users">
          <span
            v-for="user in coworkers.slice(0, 3)"
            :key="user.href"
            class="inline-coworkers-list__user"
          >
            <BasicAvatar
              :image="user.avatar"
              size="small"
              roundness="full"
            />
          </span>
        </span>
        <span
          v-if="extraLength > 0"
          class="inline-coworkers-list__extra"
        >
          <BasicText color="muted">
            и ещё {{extraLength}}
          </BasicText>
        </span>
      </button>
      <TransitionFade>
        <BasicDropdown v-if="visible">
          <BasicSection appearance="conversations-dropdown">
            <SectionGroup gap="small">
              <div>
                Со специалистом взаимодействуют:
              </div>
              <div class="inline-coworkers-list__dropdown-user-list">
                <UserList :users="coworkers" />
              </div>
            </SectionGroup>
          </BasicSection>
        </BasicDropdown>
      </TransitionFade>
    </DropdownTarget>
  </span>
</template>

<script>
  import BasicAvatar from "src/components/BasicAvatar/BasicAvatar.vue";
  import BasicDropdown from "src/components/BasicDropdown/BasicDropdown.vue";
  import DropdownTarget from "src/components/DropdownTarget/DropdownTarget.vue";
  import BasicSection from "src/components/sections/BasicSection/BasicSection.vue";
  import SectionGroup from "src/components/sections/SectionGroup/SectionGroup.vue";
  import BasicText from "src/components/text/BasicText/BasicText.vue";
  import TransitionFade from "src/components/transitions/TransitionFade/TransitionFade.vue";
  import UserList from "src/components/users/UserList/UserList.vue";

  export default {
    name: 'InlineCoworkersList',
    components: {
      SectionGroup,
      BasicSection,
      BasicText,
      BasicAvatar,
      TransitionFade,
      UserList,
      BasicDropdown,
      DropdownTarget,
    },
    props: {
      coworkers: {
        type: Array,
        required: true,
      }
    },
    computed: {
      extraLength() {
        return this.coworkers.length - 3;
      }
    }
  }
</script>